import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import React, { useState } from 'react';
import { TripResponse } from '../../../store/backendApi';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { HEADER_TAB, SettingsTab, SettingsTabsType, SHARING_TAB } from './tabs';
import { SharingOptionsPage } from './sharing/SharingOptionsPage';
import { HeaderOptionsPage } from './header/HeaderOptionsPage';

export interface UpdateTripModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tripData: TripResponse;
  userId: string;
  username: string;
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
}

const tabs = [HEADER_TAB, SHARING_TAB];

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export const UpdateTripModal = (props: UpdateTripModalProps) => {
  const [currentTab, setCurrentTab] = useState<SettingsTab>(HEADER_TAB);

  return (
    <Dialog open={props.open} onClose={props.setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0
        data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 h-screen
         sm:h-auto"
        >
          <DialogPanel
            transition
            className="
            relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all
            data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200
            data-[enter]:ease-out data-[leave]:ease-in
            sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95
            w-full h-full sm:h-auto sm:rounded-lg
            "
          >
            <div>
              <div>
                <button
                  onClick={() => {
                    props.setOpen(false);
                  }}
                  className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                >
                  X
                </button>
                <div className="text-center">
                  <DialogTitle as="h2" className="text-xl font-semibold text-gray-900">
                    Trip Settings
                  </DialogTitle>

                  <div>
                    <div className="grid grid-cols-1 sm:hidden">
                      <select
                        defaultValue={currentTab.name}
                        aria-label="Select a tab"
                        className="col-start-1 row-start-1 w-full appearance-none rounded-md
                        bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1
                        -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2
                        focus:outline-indigo-600"
                      >
                        {tabs.map((tab) => (
                          <option key={tab.name}>{tab.name}</option>
                        ))}
                      </select>
                      <ChevronDownIcon
                        aria-hidden="true"
                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center
                        justify-self-end fill-gray-500"
                      />
                    </div>
                    <div className="hidden sm:block">
                      <div className="border-b border-gray-200">
                        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                          {tabs.map((tab) => (
                            <button
                              key={tab.name}
                              onClick={() => {
                                setCurrentTab(tab);
                              }}
                              className={classNames(
                                tab === currentTab
                                  ? 'border-indigo-500 text-indigo-600'
                                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                'border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap',
                              )}
                            >
                              {tab.name}
                            </button>
                          ))}
                        </nav>
                      </div>
                    </div>
                  </div>
                  {currentTab.type === SettingsTabsType.Header && (
                    <HeaderOptionsPage
                      tripData={props.tripData}
                      setHasChanges={props.setHasChanges}
                    />
                  )}
                  {currentTab.type === SettingsTabsType.Sharing && (
                    <SharingOptionsPage trip={props.tripData} username={props.username} />
                  )}
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
